const individualProductResearch = ({ language, isSavedUser }) => {
  return {
    title: "Individual Product Research",
    url: "https://sellerhook.com/?utm_source=site&utm_medium=amzscout&utm_campaign=footer",
    target: false,
    ref: false,
    isLink: false,
  };
};

export default individualProductResearch;
